import { forwardRef } from 'react';
import { IconProps } from '../iconTypes';
const SVGIcon = forwardRef<SVGSVGElement, IconProps>(({
  size = 14,
  ...props
}, svgRef) => {
  if (size) {
    props.width = size;
    props.height = size;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512" ref={svgRef} {...props}><path d="M375 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9L460.8 181c-17.2 17.2-40.6 26.9-65 26.9-16.7 0-32.3-4.4-45.8-12.2L241 305l56.4 56.4c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32v-93.8c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0L207 271l109.2-109.1c-7.8-13.5-12.2-29.1-12.2-45.8 0-24.4 9.7-47.7 26.9-65L375 7zm17 50.9l-27.1 27.2c-8.2 8.2-12.9 19.4-12.9 31 0 24.2 19.6 43.9 43.9 43.9 11.6 0 22.8-4.6 31-12.9l27.2-27.1L392 57.9zM125.7 464c29.7 0 58.2-11.8 79.2-32.8l47.2-47.2L128 259.9l-47.2 47.2c-21 21-32.8 49.5-32.8 79.2V464h77.7z" /></svg>;
});
SVGIcon.displayName = "RegularShovel";
export default SVGIcon;